import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function initCustomsMode() {
  return request({
    url: URL.mdm.basicData.initCustomsMode,
    method: 'post'
  })
}

export function listCustomsMode(data) {
  return request({
    url: URL.mdm.basicData.listCustomsMode,
    method: 'post',
    data
  })
}

export function addCustomsMode(data) {
  return request({
    url: URL.mdm.basicData.addCustomsMode,
    method: 'post',
    data
  })
}

export function updateCustomsMode(data) {
  return request({
    url: URL.mdm.basicData.updateCustomsMode,
    method: 'post',
    data
  })
}

export function deleteCustomsMode(data) {
  return request({
    url: URL.mdm.basicData.deleteCustomsMode,
    method: 'post',
    data
  })
}
